import SimpleBar from "simplebar";
import { reactive, ref } from "vue";
import { getNextHistory } from "./chatHistoryState";

let scrollChat: SimpleBar | null = null;
export const mounted = ref(false)

export const scrollState = reactive<{
  scrollPosition: "top" | "bottom" | "unknown";
  savedPosition: number
}>({
  scrollPosition: "bottom",
  savedPosition: NaN
});

export function setScrollChat(scroll: SimpleBar) {
  scrollChat = scroll;
  const el = scroll.getScrollElement();
  if (el) {
    el.addEventListener("scroll", (ev: Event) => {
      const el = ev.target;
      if (el) {
        getScrollPosition(el as HTMLElement);
      }
    });
  }
}

export function toBottomScrollChat() {
  if (scrollChat) {
    const el = scrollChat.getScrollElement();
    if (el) {
      el.scrollTop = el.scrollHeight
    }
  }
}

export function toBottomScrollChatAnimate() {
  if (scrollChat) {
    const el = scrollChat.getScrollElement();
    if (el) {
      el.scrollTo({
        top: el.scrollHeight,
        behavior: "smooth"
      })
    }
  }
}

function getScrollPosition(el: HTMLElement) {
  if (el.scrollHeight - (el.scrollTop + 2) <= el.clientHeight) {
    scrollEndEvent();
  } else if (el.scrollTop === 0) {
    scrollTopEvent();
  } else {
    scrollUnknownEvent();
  }
  return scrollState.scrollPosition;
}

function scrollEndEvent() {
  scrollState.scrollPosition = "bottom";
}

function scrollTopEvent() {
  if (scrollState.scrollPosition !== "top") {
    scrollState.scrollPosition = "top";
    getNextHistory()
  }
}

function scrollUnknownEvent() {
  scrollState.scrollPosition = "unknown";
}

export function saveScrollPosition() {
  if (scrollChat) {
    const el = scrollChat.getScrollElement();
    if (el) {
      scrollState.savedPosition = el.scrollHeight - el.scrollTop
    }
  }
  return 0
}

export function restoreScrollPosition () {
  if (scrollChat) {
    const el = scrollChat.getScrollElement();
    if (el && !isNaN(scrollState.savedPosition)) {
      el.scrollTop = el.scrollHeight - scrollState.savedPosition
    }
  }
  return 0
}
